export default "__VITE_ASSET__CjGtJCGi__"